import { Map as ImmutableMap } from 'immutable'
import { historyRedirect, HISTORY_METHOD_REPLACE, HISTORY_METHOD_PUSH } from '../../../services/navigation/index'
import { History } from '../history-types'

/**
 * Type-safe wrapper for historyRedirect specifically for Oracle components.
 * Centralizes the type compatibility handling between Oracle's History type
 * and the service's expected type.
 */
interface OracleHistoryRedirectParams {
  history: History
  url: string
  query: Record<string, unknown>
  auth: ImmutableMap<string, unknown>
  language: string
  historyMethod?: typeof HISTORY_METHOD_PUSH | typeof HISTORY_METHOD_REPLACE
}

/**
 * Navigate using history redirect with Oracle-specific typing.
 * This wrapper provides type safety for Oracle components while maintaining
 * compatibility with the underlying navigation service.
 *
 * @param params - Navigation parameters
 */
export function oracleHistoryRedirect (params: OracleHistoryRedirectParams): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  historyRedirect(params as any)
}
